import { render, staticRenderFns } from "./CheckoutModal.vue?vue&type=template&id=36d2a466&scoped=true&"
import script from "./CheckoutModal.vue?vue&type=script&lang=js&"
export * from "./CheckoutModal.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutModal.vue?vue&type=style&index=0&id=36d2a466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d2a466",
  null
  
)

export default component.exports